import { render, staticRenderFns } from "./ArticleCategories.vue?vue&type=template&id=a4c79eec&scoped=true"
import script from "./ArticleCategories.vue?vue&type=script&lang=js"
export * from "./ArticleCategories.vue?vue&type=script&lang=js"
import style0 from "./ArticleCategories.vue?vue&type=style&index=0&id=a4c79eec&prod&scoped=true&lang=css"
import style1 from "./ArticleCategories.vue?vue&type=style&index=1&id=a4c79eec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c79eec",
  null
  
)

export default component.exports